export function useCurrency() {
  const currency = (value: number | string) => {
    if (value == null || isNaN(Number(value))) return value

    const num = Math.floor(Number(value))
    return num
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".") // inserts dot as thousand separator
  }

  return { currency }
}